import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !["width", "height"].includes(prop),
})(({ width, height, theme }) => ({
  borderRadius: theme.shape.customBorderRadius[3], //25px
  color: theme.palette.primary.redPrimary,
  backgroundColor: theme.palette.primary.white,
  border: `1.5px solid ${theme.palette.primary.redPrimary}`,
  width,
  height,

  "&:hover": {
    backgroundColor: theme.palette.primary.white,
    borderColor: theme.palette.primary.redSecound,
    color: theme.palette.primary.redSecound,
  },
  "&:active": {
    backgroundColor: theme.palette.primary.redThird,
    borderColor: theme.palette.primary.redPrimary,
    color: theme.palette.primary.redPrimary,
  },
  "&:disabled": {
    backgroundColor: theme.palette.primary.white,
    border: `1.5px solid ${theme.palette.primary.redSecound}`,
    color: theme.palette.primary.redSecound,
    cursor: "not-allowed",
  },
}));

export const OutlineWarnButton = ({
  iconStart,
  iconEnd,
  width,
  height,
  children,
  ...rest
}) => {
  return (
    <StyledButton
      startIcon={iconStart}
      endIcon={iconEnd}
      width={width}
      height={height}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};
